"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const file_saver_1 = require("file-saver");
const XLSX = __importStar(require("xlsx"));
const axios_1 = __importDefault(require("axios"));
const react_select_1 = __importDefault(require("react-select"));
const StatisticTable_1 = __importDefault(require("../components/StatisticTable"));
const SearchPage_1 = __importDefault(require("../states/SearchPage"));
const SearchPage_2 = __importDefault(require("../states/SearchPage"));
const mobx_react_lite_1 = require("mobx-react-lite");
const FilterState_1 = __importDefault(require("../components/FilterState"));
const SearchResultPageStore_1 = __importDefault(require("../states/SearchResultPageStore"));
const SelectedFiltersStore_1 = __importDefault(require("../states/SelectedFiltersStore"));
const StatisticsSelectedFilters_1 = require("../components/StatisticsSelectedFilters");
const react_spinner_material_1 = __importDefault(require("react-spinner-material"));
const translate_1 = require("../helper/translate");
const Statistics = (0, mobx_react_lite_1.observer)(({ getResult, showResults, setShowResults, selectedBenchmark, setSelectedBenchmark }) => {
    const { selectedFilters } = (0, StatisticsSelectedFilters_1.useSelectedFilters)();
    const [errors, setErrors] = (0, react_1.useState)([]);
    const [showBenchmarks, setShowBenchmarks] = (0, react_1.useState)(false);
    const isSingleKpiMode = SearchPage_2.default._isSingleKpiMode;
    const isSingleCountryMode = SearchPage_2.default._isSingleCountryMode;
    const isSingleYearMode = SearchPage_2.default._isSingleYearMode;
    const results = SearchPage_2.default.results;
    const [singleKpiPerCell, setsingleKpiPerCell] = (0, react_1.useState)(true);
    const [duplicateAttributes, setDuplicateAttributes] = (0, react_1.useState)([]);
    const [cachedTableData, setCachedTableData] = (0, react_1.useState)(null);
    const tableRef = (0, react_1.useRef)(null);
    const handleExport = () => {
        const table = tableRef.current;
        if (!table)
            return;
        const wb = XLSX.utils.table_to_book(table);
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        (0, file_saver_1.saveAs)(new Blob([wbout], { type: 'application/octet-stream' }), 'StatisticTable.xlsx');
    };
    const resultMap = {
        kpi_id: "kpis",
        country_name: "countries",
        first_kpi_year: "years",
        performance_dimension_id: "performanceDimensions",
        primary_expected_outcome_id: "expectedOutcomes",
        region: "regions",
    };
    (0, react_1.useEffect)(() => {
        const identifyDuplicateAttributes = (dataArray) => {
            const uniqueValues = {
                kpi_id: new Set(),
                country_name: new Set(),
                first_kpi_year: new Set(),
                performance_dimension_id: new Set(),
                primary_expected_outcome_id: new Set(),
                region: new Set(),
            };
            const duplicates = new Set();
            dataArray.forEach((item) => {
                const { attributes } = item; // Adjust according to your data structure
                Object.keys(uniqueValues).forEach((key) => {
                    const value = attributes[key];
                    if (uniqueValues[key].has(value)) {
                        duplicates.add(key);
                    }
                    else {
                        uniqueValues[key].add(value);
                    }
                });
            });
            return Array.from(duplicates);
        };
        const attributesWithDuplicates = identifyDuplicateAttributes(results);
        setDuplicateAttributes(attributesWithDuplicates);
        setShowResults(false);
    }, [results]);
    const addError = (0, react_1.useCallback)((id, message) => {
        setErrors((prevErrors) => {
            const errorExists = prevErrors.some((error) => error.id === id);
            if (!errorExists) {
                return [...prevErrors, { id, message }];
            }
            return prevErrors.map((error) => error.id === id ? Object.assign(Object.assign({}, error), { message }) : error);
        });
    }, []);
    const removeError = (0, react_1.useCallback)((id) => {
        setErrors((prevErrors) => prevErrors.filter((error) => error.id !== id));
    }, []);
    const pageSize = {
        level1: 20,
        level2: 5,
        level3: 2,
    };
    let itemsPerPage = SearchPage_2.default.getLevelValue("level2")
        ? SearchPage_2.default.getLevelValue("level3")
            ? pageSize.level3
            : pageSize.level2
        : pageSize.level1;
    const [styles, setStyles] = (0, react_1.useState)([]);
    const [style, setStyle] = (0, react_1.useState)({});
    const [count, setCount] = (0, react_1.useState)(10);
    const [isLevel2Disabled, setIsLevel2Disabled] = (0, react_1.useState)(false);
    const [isLevel3Disabled, setIsLevel3Disabled] = (0, react_1.useState)(false);
    const [isFirstTime, setIsFirstTime] = (0, react_1.useState)(true);
    const [min, setMin] = (0, react_1.useState)('');
    const [max, setMax] = (0, react_1.useState)('');
    const [minError, setMinError] = (0, react_1.useState)('');
    const [maxError, setMaxError] = (0, react_1.useState)('');
    const [minErrorVisible, setMinErrorVisible] = (0, react_1.useState)(false);
    const [maxErrorVisible, setMaxErrorVisible] = (0, react_1.useState)(false);
    const [minErrorOpacity, setMinErrorOpacity] = (0, react_1.useState)(1);
    const [maxErrorOpacity, setMaxErrorOpacity] = (0, react_1.useState)(1);
    const [progress, setProgress] = (0, react_1.useState)(100);
    const validateThresholds = (min, max) => {
        let valid = true;
        if (!isFirstTime && min === '' && max === '') {
            setMinError('At least one of Min or Max is mandatory.');
            setMaxError('At least one of Min or Max is mandatory.');
            setMinErrorVisible(true);
            setMaxErrorVisible(true);
            setMinErrorOpacity(1);
            setMaxErrorOpacity(1);
            valid = false;
        }
        else {
            setMinError('');
            setMaxError('');
            setMinErrorVisible(false);
            setMaxErrorVisible(false);
            if (min !== '' && max !== '' && parseFloat(max) < parseFloat(min)) {
                setMaxError('Max should not be less than Min.');
                setMaxErrorVisible(true);
                setMaxErrorOpacity(1);
                valid = false;
            }
            else {
                setMaxError('');
            }
            if (min !== '' || max !== '') {
                // localStorage.setItem('min', min);
                // localStorage.setItem('max', max);
                setIsFirstTime(false);
            }
        }
        return valid;
    };
    // useEffect(() => {
    //     const storedMin = localStorage.getItem('min');
    //     const storedMax = localStorage.getItem('max');
    //     if (storedMin !== null) {
    //         setMin(storedMin);
    //     }
    //     if (storedMax !== null) {
    //         setMax(storedMax);
    //     }
    // }, []);
    const defaultValue = (0, react_1.useMemo)(() => {
        return { value: "", label: (0, translate_1.translate)("None") };
    }, []);
    const getDefaultOption = (options, levelKey) => {
        const levelValue = SearchPage_2.default.getLevelValue(levelKey);
        if (levelValue) {
            return (options.find((option) => option.value === levelValue) || defaultValue);
        }
        return defaultValue;
    };
    const topBottom = (0, react_1.useMemo)(() => {
        return [
            defaultValue,
            { value: "top", label: (0, translate_1.translate)("Top") },
            { value: "bottom", label: (0, translate_1.translate)("Bottom") },
        ];
    }, []);
    (0, react_1.useEffect)(() => {
        axios_1.default.get(`/api/search/getColumnsList/${SearchPage_1.default.locale}`).then((resp) => {
            SearchPage_2.default.columnList = resp.data.data;
        });
        axios_1.default.get("/api/search/getTableStyle").then((resp) => {
            setStyles(resp.data.data);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (SearchPage_2.default.columnList.statisticResults.benchmarks) {
            const transformed = SearchPage_2.default.columnList.statisticResults.benchmarks.map((benchmark) => ({
                value: benchmark.id,
                label: benchmark.title.en,
            }));
            const noneOption = { value: 0, label: (0, translate_1.translate)("None") };
            const optionsWithNone = [noneOption, ...transformed];
            SelectedFiltersStore_1.default.setBenchmarks(optionsWithNone);
        }
    }, [SearchPage_2.default.columnList.statisticResults.benchmarks, selectedBenchmark, SearchPage_2.default.getLevelValue("criteria")]);
    const handleSelectChange = (0, react_1.useCallback)((levelKey) => (newValue) => {
        setShowResults(false);
        if (newValue) {
            if (levelKey === "criteria" && newValue.value !== "benchmark") {
                setSelectedBenchmark(0);
            }
            SearchPage_2.default.updateLevel(levelKey, newValue.value);
        }
        else {
            SearchPage_2.default.updateLevel(levelKey, "");
            if (levelKey === "level1") {
                setCachedTableData(null);
                SearchPage_2.default.updateLevel("column", "");
                SearchPage_2.default.updateLevel("level2", "");
                SearchPage_2.default.updateLevel("level3", "");
            }
            else if (levelKey === "column") {
                SearchPage_2.default.updateLevel("level2", "");
                SearchPage_2.default.updateLevel("level3", "");
            }
            else if (levelKey === "level2") {
                SearchPage_2.default.updateLevel("level3", "");
            }
        }
    }, []);
    const handleShowStatistics = () => {
        if (!showResults) {
            setCachedTableData(null);
        }
        // searchPageStore.currentPage = 1;
        SearchPage_2.default.showStatistics = SearchPage_2.default.showStatistics + 1;
        SearchPage_2.default.displayedResult = getTableColumns(SearchPage_2.default.getLevelValue("level1")).options;
        // ?.slice(0, searchPageStore.currentPage * itemsPerPage)!;
        const selectedFilters = {
            level1Value: SearchPage_2.default.getLevelValue("level1"),
            columnValue: SearchPage_2.default.getLevelValue("column"),
            topBottomValue: SearchPage_2.default.getLevelValue("topBottom"),
            level2Value: SearchPage_2.default.getLevelValue("level2"),
            level3Value: SearchPage_2.default.getLevelValue("level3"),
            criteriaValue: SearchPage_2.default.getLevelValue("criteria"),
            benchmarkValue: SelectedFiltersStore_1.default.benchmarks[selectedBenchmark].label,
            count: count,
        };
        SelectedFiltersStore_1.default.setFilters(selectedFilters);
        setShowResults(true);
    };
    (0, react_1.useEffect)(() => {
        SearchPage_2.default.displayedResult = getTableColumns(SearchPage_2.default.getLevelValue("level1")).options;
    }, [SearchPage_2.default.currentPage]);
    const getOptionsExcludingSelected = (0, react_1.useCallback)((excludeValues) => {
        return [
            { value: "", label: (0, translate_1.translate)("None") },
            ...SearchPage_2.default.columnList.statistics.filter((option) => !excludeValues.includes(option.value)),
        ];
    }, [SearchPage_2.default.columnList.statistics]);
    const getOptions = (0, react_1.useCallback)((excludeKeys) => {
        const excludedValues = excludeKeys.map((key) => SearchPage_2.default.getLevelValue(key));
        return getOptionsExcludingSelected(excludedValues);
    }, [SearchPage_2.default.columnList.statistics, SearchPage_2.default.levels]);
    const getAllOptions = (0, react_1.useCallback)(() => getOptions([]), [getOptions]);
    const getColumnOptions = (0, react_1.useCallback)(() => getOptions(["topBottom"]), [getOptions]);
    const getLevel1Options = (0, react_1.useCallback)(() => getOptions(["topBottom"]), [getOptions]);
    const getLevel2Options = (0, react_1.useCallback)(() => getOptions(["topBottom"]), [getOptions]);
    const getLevel3Options = (0, react_1.useCallback)(() => getOptions(["topBottom"]), [getOptions]);
    const getTopBottomOptions = (0, react_1.useCallback)(() => getOptions(["column", "level1", "level2", "level3"]), [getOptions]);
    const getTableColumns = (0, react_1.useCallback)((key) => {
        return Object.assign(Object.assign({ key: key }, SearchPage_1.default.filters[key]), SearchPage_2.default.columnList.statisticResults[key]);
    }, [SearchPage_1.default.filters, SearchPage_2.default.columnList.statisticResults]);
    const styleOptions = [
        { value: "", label: (0, translate_1.translate)("None") },
        ...styles.map((item) => ({
            value: item.id,
            label: item.title.en,
        })),
    ];
    const handleStyleChange = (selectedOption) => {
        setShowResults(false);
        let selectedValue = selectedOption.value;
        let selectedStyle = styles.find((style) => style.id === selectedValue);
        setStyle(selectedStyle);
    };
    (0, react_1.useEffect)(() => {
        setErrors([]);
        const level1Value = SearchPage_2.default.getLevelValue("level1");
        const columnValue = SearchPage_2.default.getLevelValue("column");
        const topBottomValue = SearchPage_2.default.getLevelValue("topBottom");
        const level2Value = SearchPage_2.default.getLevelValue("level2");
        const level3Value = SearchPage_2.default.getLevelValue("level3");
        const criteriaValue = SearchPage_2.default.getLevelValue("criteria");
        const singleKpiAcceptedValues = ["result", "average", "benchmark"];
        const multiKpiAcceptedValues = ["fraction", "percentage"];
        setShowBenchmarks(criteriaValue === "benchmark");
        const getTopBottomLabel = () => {
            const topBottomValue = SearchPage_2.default.getLevelValue("topBottom");
            const option = topBottom.find((option) => option.value === topBottomValue);
            return option ? option.label : "";
        };
        const getCriteriaLabel = () => {
            const criteriaValue = SearchPage_2.default.getLevelValue("criteria");
            const option = SearchPage_2.default.columnList.criteria.find((option) => option.value === criteriaValue);
            return option ? option.label : "";
        };
        // Calculate cell grouping type
        const levels = ["level1", "level2", "level3", "column"];
        const isKpiMultiplying = !isSingleKpiMode && !levels.some(level => SearchPage_2.default.getLevelValue(level) === 'kpis');
        const isYearMultiplying = !isSingleYearMode && !levels.some(level => SearchPage_2.default.getLevelValue(level) === 'years');
        const isMemberMultiplying = !isSingleCountryMode && !levels.some(level => SearchPage_2.default.getLevelValue(level) === 'countries');
        const isSingleResultGrouping = !isKpiMultiplying && !isYearMultiplying && !isMemberMultiplying;
        const isMultipleResultGrouping = !isSingleResultGrouping;
        const isSingleUnitMode = multiKpiAcceptedValues.includes(criteriaValue) || criteriaValue === '' || criteriaValue === 'number' || isSingleKpiMode;
        const levelValues = [level1Value, columnValue, level2Value, level3Value];
        const disaggregationCount = levelValues.filter(value => value.includes("disaggregation")).length;
        if (!level1Value) {
            addError("level1", (0, translate_1.translate)("At least one category for the level 1 rows must be selected"));
        }
        else {
            removeError("level1");
        }
        if (disaggregationCount >= 2) {
            addError("disaggregation", (0, translate_1.translate)("Only one disaggregation can be selected for a statistics table as the results shown are for the disaggregation results"));
        }
        else {
            removeError("disaggregation");
        }
        if (topBottomValue && (columnValue || level2Value || level3Value || !isSingleUnitMode)) {
            if (!isSingleUnitMode) {
                addError("topBottom", (0, translate_1.translate)(`${getTopBottomLabel()} can only be selected when all results have the same unit.`));
            }
            else {
                addError("topBottom", (0, translate_1.translate)(`${getTopBottomLabel()} 10 can only be selected for single-column tables.`));
            }
        }
        else {
            removeError("topBottom");
        }
        if (criteriaValue == "benchmark" && !selectedBenchmark) {
            addError("benchmark", (0, translate_1.translate)(`Cell calculation criteria “KPI result in comparison to benchmarks” requires a benchmark type to be selected`));
        }
        else {
            removeError("benchmark");
        }
        if (multiKpiAcceptedValues.includes(criteriaValue) &&
            isSingleResultGrouping) {
            addError("criteria", (0, translate_1.translate)(`Cell calculation criteria ${getCriteriaLabel()} is not available for cell grouping type “Single KPI results”`));
        }
        else if (isMultipleResultGrouping && criteriaValue == "result") {
            addError("multiple", (0, translate_1.translate)(`Cell calculation criteria “KPI result (with KPI measurement unit)” is not available for cell grouping type “Multiple KPI results"`));
            if (criteriaValue !== "result" && ([level1Value, columnValue, level2Value, level3Value].includes('kpis'))) {
                removeError("multiple");
            }
        }
        else if (criteriaValue === "average") {
            if (!isSingleKpiMode && !(levelValues.includes('kpis'))) {
                addError("multiple", (0, translate_1.translate)(`The criteria "Average KPI result" is only valid when there are multiple results for a single KPI per results cell`));
            }
        }
        else {
            removeError("criteria");
            removeError("multiple");
        }
    }, [
        selectedBenchmark,
        duplicateAttributes,
        SearchPage_2.default.getLevelValue("level1"),
        SearchPage_2.default.getLevelValue("topBottom"),
        SearchPage_2.default.getLevelValue("level2"),
        SearchPage_2.default.getLevelValue("level3"),
        SearchPage_2.default.getLevelValue("column"),
        SearchPage_2.default.getLevelValue("criteria"),
        addError,
        removeError,
    ]);
    (0, react_1.useEffect)(() => {
        const level1Value = SearchPage_2.default.getLevelValue("level1");
        const columnValue = SearchPage_2.default.getLevelValue("column");
        const level2Value = SearchPage_2.default.getLevelValue("level2");
        const level3Value = SearchPage_2.default.getLevelValue("level3");
        setIsLevel2Disabled(false);
        setIsLevel3Disabled(false);
        const levelValues = [
            level1Value,
            columnValue,
            level2Value,
            level3Value,
        ].filter(Boolean);
        const occurrences = levelValues.reduce((acc, value) => {
            if (value != null) {
                const key = String(value);
                acc[key] = (acc[key] || 0) + 1;
            }
            return acc;
        }, {});
        const duplicates = Object.keys(occurrences).filter((value) => occurrences[value] > 1);
        if (duplicates.length > 0) {
            const duplicatedValue = duplicates.join(", ");
            const dataArray = SearchPage_2.default.columnList.statistics;
            const findLabelByValue = (value) => {
                const obj = dataArray.find((item) => item.value === value);
                return obj ? obj.label : "Not found";
            };
            addError("duplicateSelection", `${(0, translate_1.translate)("Category")} ${findLabelByValue(duplicatedValue)} ${(0, translate_1.translate)("can only be selected once for rows/columns.")}`);
        }
        else {
            removeError("duplicateSelection");
        }
    }, [
        SearchPage_2.default.getLevelValue("level1"),
        SearchPage_2.default.getLevelValue("level2"),
        SearchPage_2.default.getLevelValue("level3"),
        SearchPage_2.default.getLevelValue("column"),
        addError,
        removeError,
    ]);
    (0, react_1.useEffect)(() => {
        const level1Value = SearchPage_2.default.getLevelValue("level1");
        const columnValue = SearchPage_2.default.getLevelValue("column");
        const level2Value = SearchPage_2.default.getLevelValue("level2");
        const level3Value = SearchPage_2.default.getLevelValue("level3");
        const levelValues = {
            level1: level1Value,
            column: columnValue,
            level2: level2Value,
            level3: level3Value,
        };
        setIsLevel2Disabled(false);
        setIsLevel3Disabled(false);
        const valueCounts = Object.values(levelValues).reduce((acc, value) => {
            if (value != null) {
                const key = String(value);
                acc[key] = (acc[key] || 0) + 1;
            }
            return acc;
        }, {});
        const duplicates = Object.keys(valueCounts).filter((key) => valueCounts[key] > 1);
        if (duplicates.length > 0) {
            const duplicatedValues = duplicates
                .map((duplicate) => Object.keys(levelValues).filter((key) => levelValues[key] === duplicate))
                .flat();
            if (duplicatedValues.includes("level1") &&
                duplicatedValues.includes("column")) {
                setIsLevel2Disabled(true);
            }
            if ((duplicatedValues.includes("level1") &&
                duplicatedValues.includes("level2")) ||
                (duplicatedValues.includes("column") &&
                    duplicatedValues.includes("level2"))) {
                setIsLevel3Disabled(true);
            }
        }
    }, [
        SearchPage_2.default.getLevelValue("level1"),
        SearchPage_2.default.getLevelValue("column"),
        SearchPage_2.default.getLevelValue("level2"),
        SearchPage_2.default.getLevelValue("level3"),
        addError,
        removeError,
    ]);
    (0, react_1.useEffect)(() => {
        if (isLevel2Disabled) {
            SearchPage_2.default.updateLevel("level2", defaultValue.value);
            SearchPage_2.default.updateLevel("level3", defaultValue.value);
        }
        if (isLevel3Disabled) {
            SearchPage_2.default.updateLevel("level3", defaultValue.value);
        }
    }, [isLevel2Disabled, isLevel3Disabled, defaultValue, SearchPage_2.default]);
    const renderErrors = () => {
        const hasLevel1Error = errors.some((error) => error.id === "level1");
        const hasDuplicateSelection = errors.some((error) => error.id === "duplicateSelection");
        const hasTopBottomError = errors.some((error) => error.id === "topBottom");
        const hasCriteriaError = errors.some((error) => error.id === "criteria");
        const hasMultipleError = errors.some((error) => error.id === "multiple");
        const hasBenchamrkError = errors.some((error) => error.id === "benchmark");
        let filteredErrors = errors;
        if ((hasLevel1Error ||
            hasTopBottomError ||
            hasMultipleError ||
            hasCriteriaError) &&
            hasBenchamrkError) {
            filteredErrors = filteredErrors.filter((error) => error.id !== "benchmark");
        }
        if ((hasLevel1Error || hasTopBottomError || hasMultipleError) &&
            hasCriteriaError) {
            filteredErrors = filteredErrors.filter((error) => error.id !== "criteria");
        }
        if (hasLevel1Error && (hasTopBottomError || hasMultipleError)) {
            filteredErrors = filteredErrors.filter((error) => error.id !== "level1");
        }
        if (hasMultipleError && hasTopBottomError) {
            filteredErrors = filteredErrors.filter((error) => error.id !== "multiple");
        }
        if (hasDuplicateSelection) {
            filteredErrors = filteredErrors.filter((error) => error.id !== "topBottom" &&
                error.id !== "criteria" &&
                error.id !== "multiple" &&
                error.id !== "benchmark");
        }
        return ((0, jsx_runtime_1.jsx)("div", { children: filteredErrors.map((error) => ((0, jsx_runtime_1.jsx)("div", { style: { color: "red" }, children: error.message }, error.id))) }));
    };
    const renderValidationPassedMessage = () => {
        if (errors.length)
            return null;
        const level1Value = SearchPage_2.default.getLevelValue("level1");
        const columnValue = SearchPage_2.default.getLevelValue("column");
        const level2Value = SearchPage_2.default.getLevelValue("level2");
        const level3Value = SearchPage_2.default.getLevelValue("level3");
        let message = "";
        if (level1Value && !columnValue && !level2Value && !level3Value) {
            message = "Valid single column table";
        }
        else if (level1Value && columnValue && !level2Value && !level3Value) {
            message = "Valid 2 dimensional table";
        }
        else if (level1Value && columnValue && level2Value && !level3Value) {
            message = "Valid 3 dimensional table";
        }
        else if (level1Value && columnValue && level2Value && level3Value) {
            message = "Valid 4 dimensional table";
        }
        return message ? (0, jsx_runtime_1.jsx)("div", { style: { color: "green" }, children: (0, translate_1.translate)(message) }) : null;
    };
    const renderGroupingTypeMessage = () => {
        const levels = ["level1", "level2", "level3", "column"];
        const isKpiMultiplying = !isSingleKpiMode && !levels.some(level => SearchPage_2.default.getLevelValue(level) === 'kpis');
        const isYearMultiplying = !isSingleYearMode && !levels.some(level => SearchPage_2.default.getLevelValue(level) === 'years');
        const isMemberMultiplying = !isSingleCountryMode && !levels.some(level => SearchPage_2.default.getLevelValue(level) === 'countries');
        let message = "";
        if (!isKpiMultiplying && !isYearMultiplying && !isMemberMultiplying) {
            message = "Single KPI result per table cell";
        }
        else {
            let multiplyingDimensions = [];
            if (isKpiMultiplying)
                multiplyingDimensions.push("several KPIs");
            if (isYearMultiplying)
                multiplyingDimensions.push("several Years");
            if (isMemberMultiplying)
                multiplyingDimensions.push("several Members");
            message = `Multiple KPI results for ${multiplyingDimensions.join(" + ")} per table cell`;
        }
        return message ? (0, jsx_runtime_1.jsx)("div", { style: { color: "blue" }, children: (0, translate_1.translate)(message) }) : null;
    };
    const valueLabelLookup = (0, react_1.useMemo)(() => {
        const options = getAllOptions();
        const lookup = {};
        options.forEach(option => {
            lookup[option.value] = option.label;
        });
        return lookup;
    }, [getAllOptions]);
    const keyLabels = (0, react_1.useMemo)(() => ({
        level1: (0, translate_1.translate)("Level 1"),
        level2: (0, translate_1.translate)("Level 2"),
        level3: ("Level 3"),
        column: (0, translate_1.translate)("Column"),
        criteria: (0, translate_1.translate)("Criteria"),
        count: (0, translate_1.translate)("Count"),
        topBottom: (0, translate_1.translate)("Top/Bottom"),
        benchmarks: (0, translate_1.translate)("Benchmarks")
    }), []);
    const selectedFiltersDisplay = (0, react_1.useMemo)(() => {
        let filters = Object.assign({}, SelectedFiltersStore_1.default.filters);
        if (filters['topBottom'] == undefined) {
            delete filters['count'];
        }
        delete filters['criteriaValue'];
        if (!filters['criteria']) {
            filters['criteria'] = (0, translate_1.translate)("Number of KPI published");
        }
        const entriesWithValues = Object.entries(filters).filter(([_, value]) => value);
        if (entriesWithValues.length === 0) {
            return `<span style="color: blue;">${(0, translate_1.translate)("Table filters")}:</span> ${(0, translate_1.translate)("None")}`;
        }
        const displayParts = entriesWithValues.map(([key, value]) => {
            const stringValue = String(value);
            const label = keyLabels[key] || key;
            const valueLabel = valueLabelLookup[stringValue] || stringValue;
            return `<strong>${label}</strong>: ${valueLabel}`;
        });
        return `<span style="color:blue;">${(0, translate_1.translate)("Table filters")}:</span> ${displayParts.join(', ')}`;
    }, [SelectedFiltersStore_1.default.filters, keyLabels, valueLabelLookup]);
    // Extract data for selected filters display
    const selectedFiltersData = (0, react_1.useMemo)(() => {
        let filters = Object.assign({}, SelectedFiltersStore_1.default.filters);
        if (filters['topBottom'] == undefined) {
            delete filters['count'];
        }
        delete filters['criteriaValue'];
        if (!filters['criteria']) {
            filters['criteria'] = (0, translate_1.translate)('Number of KPI published');
        }
        const entriesWithValues = Object.entries(filters).filter(([_, value]) => value);
        return entriesWithValues.map(([key, value]) => {
            const stringValue = String(value);
            const label = keyLabels[key] || key;
            const valueLabel = valueLabelLookup[stringValue] || stringValue;
            return { Filter: label, Value: valueLabel };
        });
    }, [SelectedFiltersStore_1.default.filters, keyLabels, valueLabelLookup]);
    (0, react_1.useEffect)(() => {
        if (showResults) {
            const newTableData = {
                column: getTableColumns(SearchPage_2.default.getLevelValue("column")),
                level1: getTableColumns(SearchPage_2.default.getLevelValue("level1")),
                level2: getTableColumns(SearchPage_2.default.getLevelValue("level2")),
                level3: getTableColumns(SearchPage_2.default.getLevelValue("level3")),
                topBottom: SearchPage_2.default.getLevelValue("topBottom"),
                hideEmptyValues: SearchPage_2.default.getLevelValue('hideEmptyValues'),
                count: count,
                selectedBenchmark: selectedBenchmark,
            };
            setCachedTableData(newTableData);
        }
    }, [showResults, count, selectedBenchmark]);
    const renderTable = (0, react_1.useMemo)(() => {
        if (!cachedTableData || !showResults)
            return null;
        return ((0, jsx_runtime_1.jsx)(StatisticTable_1.default, { tableRef: tableRef, setProgress: setProgress, column: cachedTableData.column, level1: cachedTableData.level1, level2: cachedTableData.level2, level3: cachedTableData.level3, topBottom: cachedTableData.topBottom, hideEmptyValues: cachedTableData.hideEmptyValues, count: cachedTableData.count, getResult: getResult, selectedBenchmark: cachedTableData.selectedBenchmark }));
    }, [cachedTableData]);
    (0, react_1.useEffect)(() => {
        SelectedFiltersStore_1.default.setStatisticsResult(selectedFiltersDisplay);
    }, [selectedFiltersDisplay]);
    // useEffect(() => {
    //     if (searchPageStore.columnList.criteria.length > 0) {
    //         const defaultCriteriaValue = searchPageStore.columnList.criteria[0].value;
    //         searchPageStore.updateLevel('criteria', defaultCriteriaValue);
    //         selectedFiltersStore.setFilters({
    //             criteriaValue: defaultCriteriaValue
    //         });
    //     }
    // }, [searchPageStore.columnList.criteria]);
    const hasErrors = errors.length > 0;
    // const styleOptions = [
    //     { value: '', label: "None" },
    //     ...styles!.map((item: any) => ({
    //         value: item.id,
    //         label: item.title.en
    //     }))
    // ];
    // const handleStyleChange = (selectedOption:any) => {
    //     let selectedValue = selectedOption.value;
    //     let selectedStyle = styles.find((style : any) => style.id === selectedValue);
    //     setStyle(selectedStyle);
    // };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "statistics-component min-height", children: [(0, jsx_runtime_1.jsxs)("div", { className: "mb-1 grid grid-cols-7 gap-1", style: { position: "relative", padding: progress < 100 ? 10 : 0 }, children: [progress < 100 && (0, jsx_runtime_1.jsxs)("div", { className: "spinner-container", style: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgb(0 0 0 / 30%)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 2,
                            borderRadius: 10
                        }, children: [(0, jsx_runtime_1.jsx)(react_spinner_material_1.default, { color: "#189CD8", visible: true }), (0, jsx_runtime_1.jsxs)("p", { style: {
                                    color: "#fff",
                                    position: "absolute",
                                    fontSize: 10,
                                    fontWeight: 900
                                }, children: [progress, "%"] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, translate_1.translate)("Level 1") }), (0, jsx_runtime_1.jsx)(react_select_1.default, { defaultValue: getDefaultOption(getLevel1Options(), "level1"), options: getLevel1Options(), onChange: handleSelectChange("level1"), value: getLevel1Options().find((level) => level.value ==
                                    SearchPage_2.default.getLevelValue("level1")), isClearable: !!SearchPage_2.default.getLevelValue("level1") })] }), (0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, translate_1.translate)("Column") }), (0, jsx_runtime_1.jsx)(react_select_1.default, { defaultValue: getDefaultOption(getColumnOptions(), "column"), options: getColumnOptions(), onChange: handleSelectChange("column"), value: getColumnOptions().find((level) => level.value ==
                                    SearchPage_2.default.getLevelValue("column")), isDisabled: !SearchPage_2.default.getLevelValue("level1"), isClearable: !!SearchPage_2.default.getLevelValue("column") })] }), (0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, translate_1.translate)("Level 2") }), (0, jsx_runtime_1.jsx)(react_select_1.default, { defaultValue: getDefaultOption(getLevel2Options(), "level2"), options: getLevel2Options(), onChange: handleSelectChange("level2"), isDisabled: !SearchPage_2.default.getLevelValue("column") ||
                                    isLevel2Disabled, value: getLevel2Options().find((level) => level.value ==
                                    SearchPage_2.default.getLevelValue("level2")), isClearable: !!SearchPage_2.default.getLevelValue("level2") })] }), (0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, translate_1.translate)("Level 3") }), (0, jsx_runtime_1.jsx)(react_select_1.default, { defaultValue: getDefaultOption(getLevel3Options(), "level3"), options: getLevel3Options(), onChange: handleSelectChange("level3"), isDisabled: !SearchPage_2.default.getLevelValue("level2") ||
                                    isLevel3Disabled, value: getLevel3Options().find((level) => level.value ==
                                    SearchPage_2.default.getLevelValue("level3")), isClearable: !!SearchPage_2.default.getLevelValue("level3") })] }), (0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, translate_1.translate)("Top/Bottom") }), (0, jsx_runtime_1.jsx)(react_select_1.default, { defaultValue: getDefaultOption(topBottom, "topBottom"), options: topBottom, onChange: handleSelectChange("topBottom"), value: getTopBottomOptions().find((level) => level.value ==
                                    SearchPage_2.default.getLevelValue("topBottom")), isClearable: !!SearchPage_2.default.getLevelValue("topBottom") })] }), (0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, translate_1.translate)("Count") }), (0, jsx_runtime_1.jsx)("input", { className: "border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5", type: "text", disabled: !SearchPage_2.default.getLevelValue("topBottom"), onChange: (event) => {
                                    setShowResults(false);
                                    setCount(event.target.value);
                                }, value: count })] }), (0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, translate_1.translate)("Criteria") }), SearchPage_2.default.columnList.criteria[0] && ((0, jsx_runtime_1.jsx)(react_select_1.default, { defaultValue: SearchPage_2.default.columnList.criteria[0], options: SearchPage_2.default.columnList.criteria, value: SearchPage_2.default.columnList.criteria.find((level) => level.value ==
                                    SearchPage_2.default.getLevelValue("criteria")), onChange: handleSelectChange("criteria") }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-check text-left", children: [(0, jsx_runtime_1.jsx)("input", { id: "hide-empty-values", className: "form-check-input", type: "checkbox", checked: SearchPage_2.default.getLevelValue("hideEmptyValues"), onChange: evt => {
                                    setShowResults(false);
                                    SearchPage_2.default.updateLevel('hideEmptyValues', !SearchPage_2.default.getLevelValue("hideEmptyValues"));
                                } }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "hide-empty-values", className: "form-check-label", children: (0, translate_1.translate)("Hide empty values") })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-check text-left", children: [(0, jsx_runtime_1.jsx)("input", { id: "use-threshold", className: "form-check-input", type: "checkbox", checked: SearchPage_2.default.getLevelValue("isTresholdSeted"), onChange: evt => {
                                    setShowResults(false);
                                    const isChecked = !SearchPage_2.default.getLevelValue("isTresholdSeted");
                                    SearchPage_2.default.updateLevel('isTresholdSeted', isChecked);
                                    if (isChecked) {
                                        validateThresholds(SearchPage_2.default.getLevelValue("treshold")[0], SearchPage_2.default.getLevelValue("treshold")[1]);
                                        // if (!localStorage.getItem('min') && !localStorage.getItem('min')) {
                                        //     setMin('');
                                        //     setMax('');
                                        // }
                                    }
                                } }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "use-threshold", className: "form-check-label", children: (0, translate_1.translate)("Use threshold") })] }), SearchPage_2.default.getLevelValue("isTresholdSeted") &&
                        (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, jsx_runtime_1.jsx)("h3", { children: "Min" }), (0, jsx_runtime_1.jsx)("input", { className: "border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5", type: "number", onChange: (event) => {
                                                setShowResults(false);
                                                const newMin = event.target.value;
                                                const currentMax = SearchPage_2.default.getLevelValue("treshold")[1];
                                                validateThresholds(newMin, currentMax);
                                                // if (validateThresholds(newMin, currentMax)) {
                                                // setMin(newMin);
                                                SearchPage_2.default.updateLevel('treshold', [newMin, currentMax]);
                                                // }
                                            }, value: SearchPage_2.default.getLevelValue("treshold")[0] }), minErrorVisible && ((0, jsx_runtime_1.jsx)("p", { className: "text-red-500 text-sm error-message", style: { transition: 'opacity 1s', opacity: minErrorOpacity }, children: minError }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, jsx_runtime_1.jsx)("h3", { children: "Max" }), (0, jsx_runtime_1.jsx)("input", { className: "border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5", type: "number", onChange: (event) => {
                                                setShowResults(false);
                                                const newMax = event.target.value;
                                                const currentMin = SearchPage_2.default.getLevelValue("treshold")[0];
                                                validateThresholds(currentMin, newMax);
                                                // if (validateThresholds(currentMin, newMax)) {
                                                // setMax(newMax);
                                                SearchPage_2.default.updateLevel('treshold', [currentMin, newMax]);
                                                // }
                                            }, value: SearchPage_2.default.getLevelValue("treshold")[1] }), maxErrorVisible && ((0, jsx_runtime_1.jsx)("p", { className: "text-red-500 text-sm error-message", style: { transition: 'opacity 1s', opacity: maxErrorOpacity }, children: maxError }))] })] }), (0, jsx_runtime_1.jsx)("div", { className: "mt-1", children: (0, jsx_runtime_1.jsx)("button", { onClick: handleShowStatistics, className: "btn", style: errors.length
                                ? {
                                    background: "#cdcdcd",
                                    borderColor: "#cdcdcd",
                                }
                                : {
                                    background: "#28c76f",
                                    borderColor: "#28c76f",
                                    color: "#fff",
                                }, children: (0, translate_1.translate)("Show statistics") }) }), (0, jsx_runtime_1.jsx)("div", { className: "mt-1", children: SearchPage_2.default.showStatistics ? (0, jsx_runtime_1.jsx)("button", { onClick: handleExport, className: "btn btn-success", children: (0, translate_1.translate)("Export excel") }) : '' }), !!SearchPage_2.default.showStatistics && errors.length == 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, translate_1.translate)("Table Style") }), (0, jsx_runtime_1.jsx)(react_select_1.default, { defaultValue: styleOptions[0], options: styleOptions, onChange: handleStyleChange })] })), showBenchmarks && ((0, jsx_runtime_1.jsxs)("div", { className: "gr-last", children: [(0, jsx_runtime_1.jsx)("h3", { children: "Benchmarks" }), SelectedFiltersStore_1.default.benchmarks && ((0, jsx_runtime_1.jsx)(react_select_1.default, { defaultValue: SelectedFiltersStore_1.default.benchmarks[0], options: SelectedFiltersStore_1.default.benchmarks, onChange: (selectedOption) => {
                                    setShowResults(false);
                                    setSelectedBenchmark(selectedOption.value);
                                } }))] }))] }), (0, translate_1.translate)("Summary"), SearchResultPageStore_1.default.showSummary ? (SearchResultPageStore_1.default.showSummary && (Object.keys(SearchResultPageStore_1.default.summaryFilters).length > 0 ? ((0, jsx_runtime_1.jsx)(FilterState_1.default, { selectedFilters: SearchResultPageStore_1.default.summaryFilters, filters: SearchPage_2.default.filters })) : ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: `<span style="color: blue;">${(0, translate_1.translate)("Search filters")}: </span> ${(0, translate_1.translate)("None")}` } })))) : ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: `<span style="color: blue;">${(0, translate_1.translate)("Search filters")}: </span> ${(0, translate_1.translate)("None")}` } })), (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: selectedFiltersDisplay } }), (0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, translate_1.translate)(renderValidationPassedMessage()), renderErrors(), renderGroupingTypeMessage()] }), (0, jsx_runtime_1.jsxs)("div", { className: "table-area table-responsive", children: [(0, jsx_runtime_1.jsx)("style", { dangerouslySetInnerHTML: {
                            __html: !!(style === null || style === void 0 ? void 0 : style.style) ? JSON.parse(style.style) : "",
                        } }), !!SearchPage_2.default.showStatistics && !hasErrors && renderTable] })] }));
});
exports.default = Statistics;
